<template>     
    <GroupGL
        :top="offsetTop"
        :left="positionX"
        :x="x"
        :y="0"
        :visible="visible"
        :name="'directors'"
        :has-scroll="true"
        >
        <!--
        <TextFontAnim  v-for="(director,index) in directors" :key="index"
            :text="director.data.name[0].text" 
            :top="vw(5.5) * director.line"
            :left="0"
            :x="0"
            :y="0"
            :font-size="fontSize"
            :currentState="currentState"
            :url="`/directors/${director.slugs[0]}`"
            :isSelected="$route.path == `/directors/${director.slugs[0]}`"
            :behavior="behavior">
        </TextFontAnim>
        -->    
        <TextFontGroup 
            v-for="(director,index) in directors" :key="index"
            ref="items"
            :top="director.top"
            :left="0"
            :x="item_x"
            :y="0"
            :currentState="currentState"
            :enter="onEnterAnim"
            :leave="onLeaveAnim"
            :scaleForce="controller.Directors.enter_scale_force"
            :isResizing="true"
            :url="`/directors/${director.slugs[0]}`"
            :name="'directors'"
            :isSelected="$route.path == `/directors/${director.slugs[0]}`">
            <TextFontAnim
                :text="textWrap(director.data.name[0].text, store.width / 100 * 50, 120)" 
                :top="0"
                :left="0"
                :duration="0.5"
                :font-size="fontSize/1.6"
                :behavior="behavior"
                :letterSpacing="0"
                :lineHeight="110"
                :opacityDuration="0.25"
                :updateState="true"
                :hover="false"
                :isDirector="true">
            </TextFontAnim>
        </TextFontGroup>
        
    </GroupGL>
</template>

<script>

import Store from '@/stores/store.js'
import Data from '@/data/data.js'

import TextFontAnim from '@/components/TextFontAnim.vue'
import GroupGL from '@/components/GroupGL.vue'
import TextFontGroup from '@/components/TextFontGroup.vue'
import Bus from '@/bus/BusEvent.js'


import ControllerGUI from '@/utils/ControllerGUI'

import TweenMax from "gsap/TweenMax";
import textWrapper from '@/utils/textWrapper.js'

export default {
    name: 'directors',
    components:{
        TextFontAnim,
        GroupGL,
        TextFontGroup
    },
    data() {
        return {
            store: Store,
            controller: ControllerGUI,
            state: Store.state,
            isDesktop: Store.isDesktop,
            top: 0,
            x: 0,
            offsetTop: 0,
            item_x: Store.width,
            directors: Data.getDirectors(),
            visible: false,
            behavior: {
                mobile: 'Mobile_Condensed',
                state0:{
                    hover: 'Bold_to_Light' // Transition au hover
                },
                state0to1: {
                    selected: 'ThinWide_to_BoldCondensed', //Transtion de l'état final du hover (en state0) à l'état selected (en state1)
                    notselected: 'BoldWide_to_LightCondensed' //Transtion de l'état normal (en state0) à l'état notselected (en state1)
                },
                state1to0: {
                    selected: 'BoldNormal_to_BoldWide', //Transition de l'état selected (en state1) à l'état normal (en state0)
                    notselected: 'BoldWide_to_LightCondensed'//normalement ça sera la meme animation que `state0to1.notselected` mais jouéer à l'enver
                },
                state1: {
                    hover: 'ThinCondensed_to_BoldCondensed_Reverse', //Transition de normal(/notselected) à l'état hover(/selected)
                    hoverselected: 'ThinCondensed_to_BoldCondensed'
                }
            },
            transition: [Power3.easeIn, Power3.easeOut, Power3.easeInOut, Bounce.easeInOut]
        }
    },
    created: function(){
    },
    mounted() {
        this.resize()
        this.transitionLeft()
        Bus.$on('resize', this.resize )
        
    },
    computed: {
        currentState(){
            if(this.state.level > 1 && this.$route.path.includes('/directors')) return (this.state.level - 1) == 0 ? 0 : 1;
        },
        scaleList(){
            if(this.state.level == 0) return 1
            else if(this.state.level == 1) return 1
            else return 0.9
        },
        positionX(){
            if(this.store.isDesktop){
                return this.store.width / 100 * 25
            }
            else {
                return this.store.width / 100 * 5
            }
        },
        offsetX() {
            if( Store.isDesktop){
                return Store.width / 100 * 80
            }
            else {
                return Store.width / 100 * 100
            }
        },
        absoluteState(){
            return this.state.level;
        },
        fontSize(){
            if( this.store.isDesktop){
                return this.vw(0.09);
            }
            else {
                return this.vw(0.25);
            }
        },
    },
    methods: {
        transitionLeft(resetScale) {
            if(this.absoluteState == 2 && this.$route.path.includes('/directors')) {
                 setTimeout(() => {  
                    TweenMax.to(this, 0.5, {x: this.store.isDesktop ? -(this.store.width/100 * 7) : -this.store.width , ease: Power3.easeOut
                    });
                    this.$refs.items.forEach(item => {
                    TweenMax.to(item, 0.5, {scale: this.scaleList, ease: Power3.easeOut, onUpdate: item.setScale
                        });
                    });
                 }, 250);

 
            }
            else {
                setTimeout(() => {
                    if(resetScale && this.$route.path.includes('/directors')) {
                        this.$refs.items.forEach(item => {
                        TweenMax.to(item, 0.5, {scale: this.scaleList, ease: Power3.easeOut, onUpdate: item.setScale
                            });
                        });
                    }
                    TweenMax.to(this, 0.5, {x: 0, ease: Power3.easeOut
                    });
                }, 250);

            }
        },
        textWrap(text, containerWidth, charSize){
            return textWrapper(text, containerWidth, charSize);
        },
        enterAnim(done, immediate = false){
            //console.log("ENTER ANIM: DIRECTORS");
            // Reset Scroll position
            this.$children[0].resetScroll()
            this.visible = true
            this.$refs.items.forEach((element, index) => {
                element.onEnter(index, done, immediate)
            });
        },
        onEnterAnim(index, item, immediate){
            setTimeout(() => {
                TweenMax.to(item, this.absoluteState == 2 ? 0 : ControllerGUI.Directors.arrival_speed, {scale: this.scaleList, ease: Power3.easeOut, onUpdate: item.setScale
                 });
                 if(ControllerGUI.Directors.font_transition_enter && this.store.isDesktop && this.absoluteState < 2) item.enterFontTransition(ControllerGUI.Directors.arrival_speed)
                 TweenMax.to(item, this.absoluteState == 2 ? 0 : ControllerGUI.Directors.arrival_speed, {transition: 0, ease: this.transition[ControllerGUI.Directors.transition_enter], onUpdate: item.setPosition});
            }, 100 + (ControllerGUI.Directors.arrival_stagger + index * ControllerGUI.Directors.arrival_stagger) * (this.absoluteState == 2 ? 0 : 1));
        },

        leaveAnim(done){
            //console.log("LEAVE ANIM: DIRECTORS");
            this.$refs.items.forEach((element, index) => {
                element.onLeave(index, done)
            });

            setTimeout(() => {
                //console.log('directors finished leaving');
                this.visible = false
                
            }, ControllerGUI.Directors.departure_speed * 1000 + ControllerGUI.Directors.departure_stagger * this.$refs.items.length);
        },
        onLeaveAnim(index, item){
            setTimeout(() => {
                TweenMax.to(item, this.absoluteState == 2 ? 0 : ControllerGUI.Directors.departure_speed, {scale: ControllerGUI.Directors.leave_scale_force, ease: Power3.easeOut, onUpdate: item.setScale, onComplete: item.resetScale
                 });
                 if(ControllerGUI.Directors.font_transition_leave && this.store.isDesktop) item.leaveFontTransition(ControllerGUI.Directors.departure_speed)
                TweenMax.to(item, ControllerGUI.Directors.departure_speed, {transition: this.item_x, ease: this.transition[ControllerGUI.Directors.transition_leave], onUpdate: item.setPosition
                 });
            }, index * this.store.isDesktop ? ControllerGUI.Directors.departure_stagger : 0);


        },
        resize() {
            let interval = setInterval(() => {
                this.setHeights()
            }, 200);
            this.transitionLeft()
            setTimeout(() => {
                clearInterval(interval)
            }, 1000);
            this.item_x = this.offsetX
            if(!this.$route.name.includes('directors')) {
                this.$children[0].$children.forEach(element => {
                    element.transition = this.item_x
                    element.setPosition()
                });
            } 
        },
        setHeights() {
            for (let index = 0; index < this.directors.length; index++) {
                if( index == 0 ){
                    this.directors[index].top = 0;
                }
                else {
                    this.directors[index].top = this.store.isDesktop ?  this.directors[index-1].top + this.$children[0].$children[index].height - 8 : this.directors[index-1].top + this.$children[0].$children[index].height - 4
                    this.$children[0].$children[index-1].setPosition()
                }
            }
            if(this.store.isDesktop) this.offsetTop = this.$children[0].$children[0].height + this.store.height/100 * 6
            else  this.offsetTop = this.$children[0].$children[0].height + this.store.height/100 * 15
            Bus.$emit('updateScroll');
        },
    },

    watch: {
        absoluteState: function(newVal, oldVal){
            if(oldVal === 2) this.transitionLeft(true)
            this.transitionLeft(false)
        },
    }
}
</script>
